import axiosInstance from './http';

function logAndRethrow(endpoint, error) {
    if (error?.response) {
        console.error(`[workApi] ${endpoint} -> ${error.response.status}`, {
            url: error.response.config?.url,
            method: error.response.config?.method,
            params: error.response.config?.params,
            data: error.response.data,
            headers: error.response.headers,
        });
    } else {
        console.error(`[workApi] ${endpoint} -> network/error`, error);
    }
    throw error;
}

export default {
    async getWorks({ page = 1, contract, customer, facility, q, status, page_size, ordering, responsible
                   } = {}) {
        const params = {};
        if (page) params.page = page;
        if (page_size) params.page_size = page_size;
        if (contract) params.contract = contract;
        if (customer) params.customer = customer;
        if (facility) params.facility = facility;
        if (q) params.q = q;
        if (status) params.status = status;
        if (ordering) params.ordering = ordering;
        if (responsible !== undefined && responsible !== null && responsible !== '') {
            params.responsible = responsible;
        }

        try {
            const response = await axiosInstance.get('works/', { params });
            return response.data; // { count, next, previous, results }
        } catch (error) {
            logAndRethrow('GET works/', error);
        }
    },

    async getWork(id) {
        try {
            const response = await axiosInstance.get(`works/${id}/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`GET works/${id}/`, error);
        }
    },

    async getWorkDetail(id) {
        try {
            const response = await axiosInstance.get(`works/${id}/detail/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`GET works/${id}/detail/`, error);
        }
    },
    async listWorkTypes({ q, department_id, is_active = true } = {}) {
        const params = {};
        if (q) params.q = q;
        if (department_id) params.department_id = department_id;
        if (typeof is_active === 'boolean') params.is_active = is_active;

        try {
            const response = await axiosInstance.get('works/types/', { params });
            return response.data; // Array<WorkType>
        } catch (error) {
            logAndRethrow('GET works/types/', error);
        }
    },

    async createWork(payload) {
        // payload: { term_start?, term_end?, contract, work_type?, custom_name? }
        try {
            const response = await axiosInstance.post('works/create/', payload);
            return response.data;
        } catch (error) {
            logAndRethrow('POST works/create/', error);
        }
    },

    async updateWork(id, payload, { method = 'patch' } = {}) {
        // Supports PATCH/PUT, default PATCH
        try {
            const url = `works/${id}/`;
            const response = method === 'put'
                ? await axiosInstance.put(url, payload)
                : await axiosInstance.patch(url, payload);
            return response.data;
        } catch (error) {
            logAndRethrow(`${method.toUpperCase()} works/${id}/`, error);
        }
    },
    // POST /api/work/{id}/archive/ (архивация)
    async archiveWork(id) {
        try {
            const response = await axiosInstance.post(`works/${id}/archive/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`POST works/${id}/archive/`, error);
        }
    },

    // удаление: DELETE /api/works/{id}/delete/
    async deleteWork(id) {
        try {
            const response = await axiosInstance.delete(`works/${id}/delete/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`DELETE works/${id}/delete/`, error);
        }
    },

    // POST /api/works/{id}/unarchive/ (разархивация)
    async unarchiveWork(id) {
        try {
            const response = await axiosInstance.post(`works/${id}/unarchive/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`POST works/${id}/unarchive/`, error);
        }
    },

};
